export default __webpack_public_path__ + "bed6c014170ef010af0f3a07fdaa9eb7.png";